/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Intervals_Error_Rate_LimitedInputs */

const en_ui_intervals_error_rate_limited = /** @type {(inputs: Ui_Intervals_Error_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`intervals.icu is rate limiting us. Try again in a few minutes.`)
};

const de_ui_intervals_error_rate_limited = /** @type {(inputs: Ui_Intervals_Error_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`intervals.icu drosselt uns gerade. Versuche es in ein paar Minuten erneut.`)
};

/**
* | output |
* | --- |
* | "intervals.icu is rate limiting us. Try again in a few minutes." |
*
* @param {Ui_Intervals_Error_Rate_LimitedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_intervals_error_rate_limited = /** @type {((inputs?: Ui_Intervals_Error_Rate_LimitedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Intervals_Error_Rate_LimitedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_intervals_error_rate_limited(inputs)
	return de_ui_intervals_error_rate_limited(inputs)
});